import { useTreatmentHistoryDetailContext } from '@context/TreatmentHistoryDetail';
import dayjs from 'dayjs';

import * as styles from './styles';
import { isEmpty } from '@utils/textUtil';
import { PaymentStatusEnum } from '@api/GoodocAPI';

const TreatmentStatus = () => {
  const { treatment, treatmentPrice } = useTreatmentHistoryDetailContext();

  return (
    <div css={styles.container}>
      <div css={styles.column}>
        <div css={styles.title}>진료 항목</div>
        <div css={styles.content}>{treatment?.department.name}</div>
      </div>
      <div css={styles.column}>
        <div css={styles.title}>병원 정보</div>
        <div css={styles.content}>{treatment?.doctor?.hospital.name}</div>
      </div>
      <div css={styles.column}>
        <div css={styles.title}>진료 시간</div>
        <div css={styles.content}>
          {treatment?.treatmentEndedAt &&
            dayjs(treatment.treatmentEndedAt).format('YYYY.MM.DD HH:mm')}
        </div>
      </div>
      <div css={styles.column}>
        <div css={styles.title}>진료비</div>
        <div
          css={[
            styles.content,
            treatment?.paymentStatus === PaymentStatusEnum.PaymentFailed && styles.failed
          ]}
        >
          {isEmpty(treatmentPrice) ? '산정 중' : `${treatmentPrice}원`}
          {treatment?.paymentStatus === PaymentStatusEnum.PaymentFailed && ' - 결제 실패'}
        </div>
      </div>
    </div>
  );
};

export default TreatmentStatus;
